export default [
	'accountbox',
	'activefolder',
	'add',
	'addtableheader',
	'airplane',
	'aligncenter',
	'alignjustify',
	'alignleft',
	'alignright',
	'arrowback',
	'arrowdown',
	'arrowleft',
	'arrowright',
	'arrowup',
	'attach',
	'back',
	'background',
	'bell',
	'belloutline',
	'blockquote',
	'bmpfile',
	'bold',
	'bookmark',
	'box',
	'bulletlist',
	'car',
	'card',
	'cart',
	'cellproperties',
	'chart',
	'chat',
	'check',
	'checklist',
	'chevrondoubleleft',
	'chevrondoubleright',
	'chevrondown',
	'chevronleft',
	'chevronnext',
	'chevronprev',
	'chevronright',
	'chevronup',
	'clear',
	'clearcircle',
	'clearformat',
	'clearsquare',
	'clock',
	'close',
	'codeblock',
	'coffee',
	'collapse',
	'color',
	'columnchooser',
	'columnfield',
	'columnproperties',
	'comment',
	'contains',
	'contentlayout',
	'copy',
	'cut',
	'dataarea',
	'datafield',
	'datapie',
	'datatrending',
	'datausage',
	'decreaseindent',
	'decreaselinespacing',
	'deletecolumn',
	'deleterow',
	'deletetable',
	'description',
	'detailslayout',
	'doc',
	'docfile',
	'docxfile',
	'doesnotcontain',
	'download',
	'dragvertical',
	'edit',
	'edittableheader',
	'email',
	'endswith',
	'equal',
	'errorcircle',
	'event',
	'eventall',
	'expand',
	'expandform',
	'export',
	'exportpdf',
	'exportselected',
	'exportxlsx',
	'eyeclose',
	'eyeopen',
	'favorites',
	'fieldchooser',
	'fields',
	'file',
	'fill',
	'filter',
	'find',
	'fixcolumn',
	'fixcolumnleft',
	'fixcolumnright',
	'floppy',
	'folder',
	'font',
	'fontsize',
	'food',
	'formula',
	'fullscreen',
	'gift',
	'globe',
	'greater',
	'greaterorequal',
	'group',
	'growfont',
	'handlehorizontal',
	'handlevertical',
	'header',
	'help',
	'hidepanel',
	'hierarchy',
	'home',
	'image',
	'imgarlock',
	'imgarunlock',
	'import',
	'importselected',
	'inactivefolder',
	'increaseindent',
	'increaselinespacing',
	'indent',
	'indeterminatestate',
	'info',
	'insertcolumnleft',
	'insertcolumnright',
	'insertrowabove',
	'insertrowbelow',
	'inserttable',
	'isblank',
	'isnotblank',
	'italic',
	'jpgfile',
	'key',
	'less',
	'lessorequal',
	'like',
	'link',
	'lock',
	'login',
	'map',
	'mediumiconslayout',
	'mention',
	'menu',
	'mergecells',
	'message',
	'minus',
	'money',
	'moon',
	'more',
	'movetofolder',
	'music',
	'newfolder',
	'notequal',
	'optionsgear',
	'orderedlist',
	'ordersbox',
	'overflow',
	'palette',
	'panelleft',
	'panelright',
	'parentfolder',
	'paste',
	'pasteplaintext',
	'pdffile',
	'percent',
	'photo',
	'photooutline',
	'pin',
	'pinleft',
	'pinmap',
	'pinright',
	'plus',
	'pptfile',
	'pptxfile',
	'preferences',
	'print',
	'product',
	'pulldown',
	'range',
	'redo',
	'refresh',
	'remove',
	'rename',
	'repeat',
	'return',
	'revert',
	'rowfield',
	'rowproperties',
	'rtffile',
	'runner',
	'save',
	'search',
	'selectall',
	'send',
	'sendfilled',
	'share',
	'showpanel',
	'shrinkfont',
	'smalliconslayout',
	'sortdown',
	'sortdowntext',
	'sorted',
	'sortup',
	'sortuptext',
	'spindown',
	'spinleft',
	'spinnext',
	'spinprev',
	'spinright',
	'spinup',
	'splitcells',
	'square',
	'startswith',
	'stickcolumn',
	'strike',
	'subscript',
	'sun',
	'superscript',
	'svgfile',
	'tableproperties',
	'tags',
	'taskcomplete',
	'taskhelpneeded',
	'taskinprogress',
	'taskrejected',
	'taskstop',
	'tel',
	'textdocument',
	'tips',
	'to',
	'todo',
	'toolbox',
	'trash',
	'triangledown',
	'triangleleft',
	'triangleright',
	'triangleup',
	'txtfile',
	'underline',
	'undo',
	'unfixcolumn',
	'unlock',
	'unpin',
	'unselectall',
	'upload',
	'user',
	'variable',
	'verticalalignbottom',
	'verticalaligncenter',
	'verticalaligntop',
	'video',
	'warning',
	'xlsfile',
	'xlsxfile',
]